import {
    styled,
    Box,
    ToggleButtonGroup,
    ToggleButton,
    Tabs,
} from "@mui/material";

export const S = {
    Search: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: theme.spacing(5),
    })),

    Inner: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        gap: theme.spacing(5),
        alignItems: "center",
    })),

    SearchField: styled(Box)(({ theme }) => ({
        flexGrow: 1,
        mr: theme.spacing(2),
    })),

    SearchViewGroup: styled(ToggleButtonGroup)(({ theme }) => ({
        gap: theme.spacing(5),
    })),

    SearchViewButton: styled(ToggleButton)(({ theme }) => ({
        border: `1px solid ${theme.palette.grey[500]} !important`,
        borderRadius: theme.spacing(4),

        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),

        "&.MuiToggleButtonGroup-firstButton": {
            borderTopRightRadius: theme.spacing(4),
            borderBottomRightRadius: theme.spacing(4),
        },

        "&.MuiToggleButtonGroup-middleButton": {
            borderRadius: theme.spacing(4),
        },

        "&.MuiToggleButtonGroup-lastButton": {
            borderRadius: theme.spacing(4),
        },
    })),

    SearchViewButtonInner: styled(Box)(({ theme }) => ({
        display: "flex",
        gap: theme.spacing(2),
        alignContent: "center",
    })),
    Tabs: styled(Tabs)(({ theme }) => ({
        "& .MuiTabs-flexContainer": {
            display: "flex",
            gap: theme.spacing(4),
        },

        "& .MuiTabs-indicator": {
            display: "none",
        },

        "& .MuiTab-root": {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.purple.main,
            border: `1px solid ${theme.palette.purple.main}`,
            borderRadius: theme.spacing(6),
            padding: theme.spacing(2.5, 5),
            transition: "background-color 0.3s ease-in-out",
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(3),
            fontSize: theme.typography.pxToRem(14),
            alignItems: "center",
            justifyContent: "center",
            minHeight: "fit-content",
        },

        "& .MuiTab-root.Mui-selected": {
            backgroundColor: theme.palette.purple.main,
            color: theme.palette.common.white,
            fontWeight: 600,
        },

        "& .MuiTab-root .MuiTab-icon": {
            marginBottom: 0,
        },
    })),
};
